(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Dark Mode Toggle
  class DarkModeToggle {
    constructor() {
      this.toggle = document.getElementById('dark-mode-toggle');
      this.root = document.documentElement;
      this.body = document.body;
      this.storageKey = 'prinjekt-dark-mode';
      this.systemMode = window.matchMedia('(prefers-color-scheme: dark)');
      this.preference = null;
      try { this.preference = localStorage.getItem(this.storageKey); } catch (error) {} 

      if (this.toggle) {
        this.init();
      }
    }

    init() {
      this.applyMode(this.root.dataset.theme === 'light' ? 'light' : 'dark');
      this.toggle.addEventListener('click', () => this.handleToggle());
      this.systemMode.addEventListener('change', () => {
        if (this.preference !== 'true' && this.preference !== 'false') {
          this.applyMode(this.systemMode.matches ? 'dark' : 'light');
        }
      });
      window.addEventListener('storage', (event) => {
        if (event.key === this.storageKey || event.key === null) {
          this.preference = event.newValue;
          this.applyMode(this.preference === 'true' ? 'dark' : this.preference === 'false' ? 'light' : this.systemMode.matches ? 'dark' : 'light');
        }
      });
    }

    handleToggle() {
      const mode = this.root.dataset.theme === 'dark' ? 'light' : 'dark';
      this.preference = String(mode === 'dark');
      this.applyMode(mode);
      try {
        localStorage.setItem(this.storageKey, String(mode === 'dark'));
      } catch (error) {
        // The selected mode still works for this page without storage access.
      }
    }

    applyMode(mode) {
      const isDark = mode === 'dark';
      this.root.classList.add('theme-switching');
      this.root.dataset.theme = mode;
      this.root.style.colorScheme = mode;
      this.body.classList.toggle('dark-mode', isDark);
      this.toggle.setAttribute('aria-checked', isDark.toString());
      this.toggle.setAttribute(
        'aria-label',
        isDark ? 'Dunklen Modus deaktivieren' : 'Dunklen Modus aktivieren'
      );
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.root.classList.remove('theme-switching'));
      });
    }
  }

  // Initialize dark mode toggle when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new DarkModeToggle());
  } else {
    new DarkModeToggle();
  }

  } catch(e) { console.error(e); }
})();
})();
